module.exports = __webpack_public_path__ + "static/2-fa0e3f3a1df7a3d22614e00794b5cbaa.jpg";